<!--  -->
<template>
  <div class='EchartPractice'>
    <div :class="className"
         :id="id"
         :style="{width: '100%', height: '250px'}"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'echart-circle',
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    id: {
      type: String,
      default: 'chart',
    },
    titletop: {
      type: String,
    },
    itemsData: {
      type: Array,
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.DrawBarChart()
  },
  watch: {
    itemsData: {
      handler(newName, oldName) {
        if (oldName) {
          this.DrawBarChart()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    DrawBarChart() {
      this.chart = echarts.init(document.getElementById(this.id))

      // 调用showLoading方法
      this.chart.showLoading({
        text: 'loading',
        color: '#0084cd',
        textColor: '#0084cd',
        maskColor: 'rgba(255, 255, 255, 0.2)',
        zlevel: 0,
      })

      let colors = ['#179F5D', '#4A8AF3', '#DA4C3F']
      var app = {}

      let option
      let datas = this.itemsData

      option = {
        tooltip: {
          trigger: 'item',
        },
        icon: 'circle',
        title: {
          text: this.titletop,
          left: 'left',
          textStyle: {
            color: '#666',
            fontWeight: '100', //粗细
            fontSize: 13,
          },
        },
        legend: {
          bottom: '15%',
          left: 'center',
          type: 'scroll',
        },

        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            height: '80%',
            minAngle: 10,
            label: {
              alignTo: 'edge',
              formatter: '{name|{b}}\n{time|{c} }',
              // minMargin: 50,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: '#999',
                },
              },
            },

            data: datas,
          },
        ],
      }
      setTimeout(() => {
        // setOption前隐藏loading事件
        this.chart.hideLoading()
        this.chart.setOption(option, true)
      }, 1000)
      //  this.chart.setOption(option)
    },
  },
}
</script>
<style lang="less"  scoped>
.EchartPractice {
  padding-top: 10px;
  margin: 0 auto;
  width: 95%;
}
</style>